import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import VersionsList from '../../VersionListPage';
import GammeListPage from '../../GammeListPage';
import ModelsList from '../../ModelsListPage';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography variant="inherit">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function PanelCatalog({ history }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    const { state } = history.location;
    if (state?.isGamme) {
      setValue(2);
    }
    if (state?.isModel) {
      setValue(1);
    }
    if (state?.isVersion) {
      setValue(0);
    }
  }, [history.location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="inherit" elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Versions" {...a11yProps(0)} />
          <Tab label="Modèles" {...a11yProps(1)} />
          <Tab label="Gammes" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <VersionsList />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ModelsList />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <GammeListPage />
      </TabPanel>
    </div>
  );
}
